import { call, put, takeLatest } from 'redux-saga/effects';
import {
  fetchBookmarksRequest,
  fetchBookmarksSuccess,
  fetchBookmarksFailure,
} from '../slice/getBookmarkSlice';
import { fetchBookmarksApi } from '@src/api/apiService';

export function* fetchBookmarks(
  action: ReturnType<typeof fetchBookmarksRequest>
): Generator<any, void, any> {
  try {
    const { offset, limit, search } = action.payload;

    const response = yield call(
      fetchBookmarksApi,
      offset,
      limit,
      search
    );

    yield put(
      fetchBookmarksSuccess({
        ...response.data,
        offset,
      })
    );
  } catch (error: any) {
    yield put(
      fetchBookmarksFailure(
        error?.response?.data?.detail ||
        error.message ||
        'Unknown error'
      )
    );
  }
}

export function* getBookmarkSaga() {
  yield takeLatest(fetchBookmarksRequest.type, fetchBookmarks);
}
